export default __webpack_public_path__ + "static/flareup-site-4ab4e9e185648dc3cc4d8f2a1a606e9e.png";